import product from './product';
import products from './products';
import landlords from './landlords';
import tenants from './tenants';
import zones from './zones';
import permits from './permits';

export default {
  namespaced: true,
  modules: {
    product,
    products,
    landlords,
    tenants,
    zones,
    permits,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/products/index.js